import React from 'react';
import * as Types from './action_types'

const initialState = {
  favorites: [],
  toast: undefined
};

// Reducer
export default function favoritesReducer(state = initialState, action) {
  switch (action.type) {
    case Types.FETCH_SUCCESS:
      return {
        ...state,
        favorites: action.favorites,
      };
    case Types.LOVE:
      return {
        ...state,
        favorites: state.favorites.concat(action.favorite),
        toast: (
          <span>
            Added to <a href="/your-favorites/inspiration" target="_blank">your favorites</a>
          </span>
        ),
      };
    case Types.UNLOVE:
      return {
        ...state,
        favorites: removeFavorite(state.favorites, action.favorite_id),
        toast:(
          <span>
            Removed from <a href="/your-favorites/inspiration" style={{textDecoration: "underline"}} target="_blank">your favorites</a>
          </span>
        ),
      };
    case Types.CLEAR:
      return initialState;
    case Types.CLEAR_TOAST:
      return {
        ...state,
        toast: undefined
      };
    default:
      return state;
  }
}

function removeFavorite(favorites, favorite_id) {
  let index = favorites.findIndex(function (favorite) {
    return favorite.id === favorite_id
  });

  if(index > -1) {
    favorites.splice(index, 1);
  }

  return favorites;
}
